import { useCallback } from "react";
import { ExportButton } from "~/pages/Compliance/Common/ExportButton";
import { exportComplianceClients } from "../exportUtil";

export const ClientsExportButton = () => {
  const onExport = useCallback(() => exportComplianceClients(), []);

  return <ExportButton onExport={onExport} testId="export-clients-button" />;
};
